const data = {
	"body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"2\"><path stroke-linecap=\"round\" d=\"M11.029 2.54a2 2 0 0 1 1.942 0l7.515 4.174a1 1 0 0 1 .514.874v8.235a2 2 0 0 1-1.029 1.748l-7 3.89a2 2 0 0 1-1.942 0l-7-3.89A2 2 0 0 1 3 15.824V7.588a1 1 0 0 1 .514-.874L11.03 2.54Z\"/><path stroke-linecap=\"round\" d=\"m7.5 4.5l9 5V13M6 12.328L9 14\"/><path d=\"m3 7l9 5m0 0l9-5m-9 5v10\"/></g>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
